import { TabsContent } from "@/components/ui/tabs";
import { EmptyState, StatusBadge, inr } from "@/components/bits";
import { fmtDate } from "@/lib/api";

export function EmployeesTab({ employees }) {
  return (
    <TabsContent value="employees">
      {employees.length === 0 ? (
        <EmptyState title="No employees yet" description="When a candidate reaches the Joined stage in your ATS, their employee record is created automatically." testId="employees-empty" />
      ) : (
        <div className="bg-white border border-border/60 rounded-xl overflow-x-auto">
          <table className="w-full text-sm" data-testid="employees-table">
            <thead className="bg-[#F8FAFC] border-b border-border/60 text-left text-xs text-muted-foreground">
              <tr>
                <th className="px-5 py-3.5 font-semibold">Employee</th>
                <th className="px-5 py-3.5 font-semibold">Designation</th>
                <th className="px-5 py-3.5 font-semibold">Joined</th>
                <th className="px-5 py-3.5 font-semibold">CTC</th>
                <th className="px-5 py-3.5 font-semibold">Status</th>
              </tr>
            </thead>
            <tbody>
              {employees.map((e) => (
                <tr key={e.id} className="border-b border-border/40" data-testid={`employee-row-${e.id}`}>
                  <td className="px-5 py-4">
                    <p className="font-semibold text-[#0B1B3D]">{e.name}</p>
                    <p className="text-xs text-muted-foreground">{e.emp_code}</p>
                  </td>
                  <td className="px-5 py-4">{e.designation}<p className="text-xs text-muted-foreground">{e.department}</p></td>
                  <td className="px-5 py-4 text-xs">{fmtDate(e.joining_date)}</td>
                  <td className="px-5 py-4 font-semibold">{inr(e.ctc)}</td>
                  <td className="px-5 py-4"><StatusBadge status={e.status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </TabsContent>
  );
}
